import { UserRole } from '@/shared/user-role';
import { UserTarget } from '@/shared/user-target';

export interface User {
    id?: string | null;
    partnerPracticeId: string | null;
    firstName: string;
    lastName: string;
    email: string;
    activatedDate?: string | null;
    isArchived?: boolean;
    version?: number;
    createdDate?: string | Date | null;
    createdBy?: string | null;
    lastModifiedDate?: string | Date | null;
    lastModifiedBy?: string | null;
    roles: Array<UserRole>;
    targets: Array<UserTarget>;
}

export function createUser(partnerPracticeId: string | null): User {
    return {
        partnerPracticeId,
        firstName: '',
        lastName: '',
        email: '',
        roles: new Array<UserRole>(),
        targets: new Array<UserTarget>(),
    };
}
